import React, { } from 'react'
import { connect } from 'react-redux'

const connected = connect(store => {
  return {
    facilityGroup: store.facilities.filter.facilityGroup,
  }
})

const FacilityGroupActive = ({ dispatch, facilityGroup }) => {
  return (
    <div>
      Active: {facilityGroup?.name}
    </div>
  )
}

export default connected(FacilityGroupActive)
